<his-documentation-link
	[target]="moduleOptions.DOCUMENTATION_ARTICLE"
	[title]="moduleOptions.DOCUMENTATION_TITLE">
</his-documentation-link>

<p-header><h2>{{'fs.res.publication.search.editimportcandidates' | hisUi}}</h2></p-header>

<button type="submit" (click)="back()">
 	<span>{{'fs.res.publication.search.backtoimport'|hisUi}}</span>
</button>

<div>
	<!-- delete confirmation dialog from common package -->
	<res-confirmation-dialog></res-confirmation-dialog>
	<!-- res information dialog - record can not be deleted due to connections in other objects -->
	<res-information-dialog></res-information-dialog>

	<p-panel>
		<div class="infoMessage">{{'fs.res.publication.import.orcid.info' | hisUi}}</div>
	</p-panel>

	<his-search-result #SearchResultComponent
		[showTitle]="true"
		[showNewSearchButton]="false"
		[showChangeSearchButton]="false"
		defaultActionRoute="/pub/view/:id"
		idColumn="Publication.id"
		defaultColumn="Publication.title"
		[resultListTemplate]="publicationService.showList ? resultListTemplate : null"> <!-- without this, the normal table is displayed -->

		<ng-container *ngIf="showBackButton" customResultButtons>
            <button (click)="back()"><span>{{'common.back' | hisUi }}</span></button>
		</ng-container>

		<ng-template #resultListTemplate let-data let-firs="first" let-total="totalRecords" let-rows="rowsPerPage">
			<res-publication-search-result-list
                [data]="data"
                [compName]="'importResultview'"
                [totalRecords]="total"
                [rowsPerPage]="rows"
                [first]="firs"
                [customActionButtonsTemplate]="duplicatesButtonTemplate"
                [disableActionButtons]="false"
				(page)="page($event)"
				[showNewSearchButton]="false"
                [showChangeSearchButton]="false"
                [showNewPublicationMessage]="false"
                [prevPage]="'importCandidates'">
			</res-publication-search-result-list>
		</ng-template>

		<ng-container customResultButtonsAfterJobStarter>
			<button (click)="publicationService.switchListTable('importResultview', null)" class="transparent">
				<img hisImage="TEXT_LIST_BULLETS" class="inlineicon" [title]=" ">
				<span>{{'psv.bau.plan.listenAnsicht' | hisUi}}</span>
			</button>
		</ng-container>

		<ng-template #rowAction let-row="row">
			<!-- edit button -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_EDIT)">
				<a routerLink="/pub/edit/{{row.get('Publication.id')}}" [queryParams]="getEditlinkQueryParams()"
				    hisImage="pencil" [title]="'common.editOf' | hisUi:row.get('Publication.title')" (click)="onBeforeNavigate()"></a>
            </ng-container>

            <!-- detail view -->
			<a routerLink="/pub/view/{{row.get('Publication.id')}}" [queryParams]="getViewlinkQueryParams()"  hisImage="magnifier_detail" [title]="'common.showOf' | hisUi:row.get('Publication.title')"></a>

            <ng-container [ngTemplateOutlet]="duplicatesButtonTemplate" [ngTemplateOutletContext]="{row: row}"></ng-container>

			<!-- delete button -->
			<ng-container *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_DELETE)">
                <img hisImage="hyphen" class="inlineicon treeAction hyphen">

				<button (click)="deleteRow(row)" hisImage="delete" class="icon" [title]="'common.deleteOf' | hisUi:row.get('Publication.title')"></button>
			</ng-container>
		</ng-template>

        <!-- Rechteabsicherung des Duplikats-Buttons muss _im_ Template passieren, da dieses auch an res-publication-search-result-list übergeben wird -->
        <ng-template #duplicatesButtonTemplate let-row="row">
             <res-publication-duplicates-button *ngIf="auth.hasAnyArray(moduleOptions.RIGHT_EDIT)"
                 [row]="row" prevPage="importCandidates">
             </res-publication-duplicates-button>
        </ng-template>
	</his-search-result>
	<br/>
</div>
